import { useState, useRef, useImperativeHandle, useEffect } from 'react';
import { useTranslate } from "../../../features/translation/hooks/use-translation";
import createValidator from '../services/validate-input';

const useInput = (props) => {
    const { t } = useTranslate();
    const validateInput = createValidator(t); 
    const ref = useRef();
    const [value, setValue] = useState(props.defaultValue || '');
    const [disabled, setDisabled] = useState(props.disabled || false);
    const [error, setError] = useState(null);
    const [displayError, setDisplayError] = useState(false);

    const reset = () => {
        setValue(props.defaultValue || '');
        ref.current.value = props.defaultValue || '';
        setDisplayError(false);
        props.onReset?.();
    };

    const validate = () => {
        //console.log("validation check")
        const err = validateInput(props, value);
        setError(err);

        props.onValidate?.();
    };


    const update = (value) => {
        //console.log('UPDATED VALUE')
        setValue(value)
        ref.current.value = value
        if (props.onUpdate){
            props.onUpdate()
        }

    }

    /* Validates value on change */
    useEffect(() => {
        validate()
    }, [value])


    const onChange = (e) => {
        setDisplayError(false)
        let { value, type, name } = e.target
        if (type === "checkbox"){
            value = e.target.checked
        }

        setValue(value)
        ref.current.value = value

        setTimeout(() => {
            if (value === e.target.value){
                setDisplayError(true)
            }
        }, 2000); 

        if (props.onChange){
            props.onChange(e)
        }

        // Because async issues
    }

    const onBlur = () => {
        if (!displayError) setDisplayError(true)
    }
    // TODO React.19: move to parent function?
    useImperativeHandle(ref, () => ({
        reset,
        validate,
        setValue: (value) => update(value),
        getId: () => props.id,
        value,
        name: props.name,
        id: props.id,
        getName: () => props.name,
        isValid: () => !error,
        setDisabled: (value) => setDisabled(value),
        setDisplayError: (value) => setDisplayError(value)
    }), [error]);    

    return {
        ref,
        bind: {
            value,
            onChange,
            onBlur,
            reset,
            disabled,
            error,
            displayError
        }
    }
}

export default useInput;